export const en = {
  'backoffice.provider.manual': 'Manual',
  'backoffice.selfService': 'Online / self-service',
  'backoffice.otherPlan': 'Other',
  'backoffice.refundStatus.pendingApproval': 'Awaiting approval',
  'backoffice.refundStatus.requested': 'Requested at provider',
  'backoffice.range.thisMonth': 'This month',
  'backoffice.range.lastMonth': 'Last month',
  'backoffice.range.last30': 'Last 30 days',
  'backoffice.range.thisYear': 'This year',
  'backoffice.range.custom': 'Custom',
  'backoffice.statement.title': 'Monthly statement',
  'backoffice.statement.description': "Every payment and refund of the month in the gym's time zone, with invoice numbers and totals, as a PDF. It is an internal accounting document, not a tax invoice: issue tax invoices on rs.ge.",
  'backoffice.statement.failed': 'Statement failed',
  'backoffice.downloadPdf': 'Download PDF',
  'backoffice.exportCsv': 'Export CSV',
  'backoffice.exportFailed': 'Export failed',
  'backoffice.nothingToShow': 'Nothing to show for this period.',
  'backoffice.count': 'Count',
  'backoffice.amount': 'Amount',
  'backoffice.share': 'Share',
  'backoffice.total': 'Total',
  'backoffice.paymentCount.one': '{count} payment',
  'backoffice.paymentCount.other': '{count} payments',
  'backoffice.period': 'Period',
  'backoffice.from': 'From',
  'backoffice.to': 'To',
  'backoffice.compareWith': 'Compare with',
  'backoffice.previousPeriod': 'Previous period',
  'backoffice.today': 'Today',
  'backoffice.day': 'Day',
  'backoffice.week': 'Week',
  'backoffice.month': 'Month',
  'backoffice.payments': 'Payments',
  'backoffice.refunds': 'Refunds',
  'backoffice.refunded': 'Refunded',
  'backoffice.gross': 'Gross',
  'backoffice.averagePayment': 'Average payment',
  'backoffice.visits': 'Visits',
  'backoffice.newMembers': 'New members',
  'backoffice.member': 'Member',
  'backoffice.method': 'Method',
  'backoffice.byMethod': 'By method',
  'backoffice.byStaff': 'By staff',

  'analytics.chart': 'Chart',
  'analytics.noComparison': 'No comparison',
  'analytics.rollupNote': 'Totals through {date} as of {time}; later days are live.',
  'analytics.vs': 'vs {value}',
  'analytics.points': '{points} pp',
  'analytics.fromZero': 'from 0',
  'analytics.quarter': 'Q{quarter} {year}',
  'analytics.quarterSpan': 'Q{quarter} {year} ({span})',
  'analytics.weekOf': 'Week of {span}',
  'analytics.perDay': '{label} per day',
  'analytics.perWeek': '{label} per week',
  'analytics.perMonth': '{label} per month',
  'analytics.perQuarter': '{label} per quarter',
  'analytics.trend.emptyTitle': 'Nothing to chart for this period',
  'analytics.trend.emptyDescription': 'Payments, memberships and visits show up here once there is activity.',
  'analytics.membershipFlow': 'Membership flow',
  'analytics.flow.first': 'First membership',
  'analytics.flow.renewed': 'Renewed or returned',
  'analytics.flow.churned': 'Churned',
  'analytics.flow.net': 'Net change',
  'analytics.flow.activeAtEnd': 'Active at the end',
  'analytics.change': 'Change',
  'analytics.share': 'Share of the total',
  'analytics.readBars': '{label}. Hover a bar, or use the arrow keys, to read it.',
  'analytics.flow.emptyTitle': 'No membership movement in this period',
  'analytics.flow.emptyDescription': 'New, renewed and churned memberships show up here per bucket.',

  'finance.title': 'Finance',
  'finance.description': 'Revenue, recurring revenue and members for the selected period, compared with an earlier one.',
  'finance.ledger': 'Ledger',
  'finance.compare.previousPeriod': 'vs previous period',
  'finance.compare.lastYear': 'vs last year',
  'finance.compare.lastYearShort': 'Last year',
  'finance.periodNote': "{period} in the gym's time zone ({timezone}).",
  'finance.periodNoteCompared': "{period} in the gym's time zone ({timezone}), compared with {comparison}.",
  'finance.revenue': 'Revenue',
  'finance.revenueDescription': 'Payments on the day they were paid, refunds on the day they completed.',
  'finance.netRevenue': 'Net revenue',
  'finance.netRevenueHint': 'Gross minus refunds',
  'finance.grossRevenue': 'Gross revenue',
  'finance.mrrShort': 'Recurring revenue (MRR)',
  'finance.trendTitle': 'Trend',
  'finance.trend.perDay': "Per day in the gym's time zone.",
  'finance.trend.perWeek': "Per week in the gym's time zone.",
  'finance.trend.perMonth': "Per month in the gym's time zone.",
  'finance.trend.dashed': 'The dashed line is the comparison period.',
  'finance.granularityLabel': 'Granularity',
  'finance.tooMany.day': 'Too many days for this period',
  'finance.tooMany.week': 'Too many weeks for this period',
  'finance.tooMany.month': 'Too many months for this period',
  'finance.recurringRevenue': 'Recurring revenue',
  'finance.recurringRevenueDescription': 'Memberships active at the end of the period, how many started, renewed and churned in it.',
  'finance.mrr': 'Monthly recurring revenue',
  'finance.mrrHint': 'Plan prices of active memberships per 30 days',
  'finance.activeMemberships': 'Active memberships',
  'finance.autoRenewHint': '{share} renew automatically',
  'finance.newMemberships': 'New memberships',
  'finance.newMembershipsHint': '{first} first, {repeat} repeat',
  'finance.renewals': 'Renewals',
  'finance.renewalsHint': '{count} automatic',
  'finance.churnRate': 'Churn rate',
  'finance.churnRateHint': '{count} ended without a successor',
  'finance.renewalRate': 'Renewal rate',
  'finance.renewalRateHint': 'Of memberships that came up for renewal',
  'finance.autoRenewShare': 'Auto-renew share',
  'finance.autoRenewShareHint': 'Of active memberships',
  'finance.ended': 'Ended',
  'finance.endedHint': 'Reached their end or were cancelled',
  'finance.flow.perDay': "Memberships that started (a member's first, or a renewal or return) and memberships that ended without a successor, per day.",
  'finance.flow.perWeek': "Memberships that started (a member's first, or a renewal or return) and memberships that ended without a successor, per week.",
  'finance.flow.perMonth': "Memberships that started (a member's first, or a renewal or return) and memberships that ended without a successor, per month.",
  'finance.members': 'Members',
  'finance.activeMembers': 'Active members',
  'finance.activeMembersHint': 'With a membership at the end of the period',
  'finance.countedAt': 'Counted at {branches}: money taken there (online payments belong to no branch), memberships bought there and the members holding them, and visits at its doors. New members are the whole gym’s, since members belong to every branch.',
  'finance.newMembersHint': 'Joined in the period',
  'finance.revenuePerActiveMember': 'Revenue per active member',
  'finance.visitsPerActiveMember': 'Visits per active member',
  'finance.visitsInPeriod.one': '{count} visit in the period',
  'finance.visitsInPeriod.other': '{count} visits in the period',
  'finance.atRisk': 'At risk',
  'finance.atRiskHint': 'Active, no visit in the last 14 days',
  'finance.sources': 'Where the money came from',
  'finance.byPlan': 'By plan',
  'finance.byProvider': 'By provider',
  'finance.byStaffDescription': 'Who recorded the payment. Online purchases are grouped as self-service.',
  'finance.outlook': 'Outlook',
  'finance.outlookDescription': 'As of now, whatever period is selected.',
  'finance.endingIn.one': 'Ending in {count} day',
  'finance.endingIn.other': 'Ending in {count} days',
  'finance.membershipCount.one': '{count} membership',
  'finance.membershipCount.other': '{count} memberships',
  'finance.endingSoonHint': '{value} in plan prices, no next membership yet. {count} renew automatically ({autoRenewValue}).',
  'finance.pendingPayments': 'Pending payments',
  'finance.pendingPaymentsHint': '{count} started in the last {days} days and not paid yet',
  'finance.openInLedger': 'Open in ledger',
  'finance.refundsAwaitingApproval': 'Refunds awaiting approval',
  'finance.requestCount.one': '{count} request',
  'finance.requestCount.other': '{count} requests',
  'finance.reviewRefunds': 'Review refunds',

  'reports.title': 'Reports',
  'reports.description': 'Choose the data, the period, how to group it, filters and a comparison. Save the view to run it again, share it with the finance team, or export it.',
  'reports.exportPdf': 'Export PDF',
  'reports.library': 'Library',
  'reports.libraryDescription': 'Start from a built-in report or one you saved.',
  'reports.builtInHeading': 'Built in',
  'reports.builtIn.revenueByPlan': 'Revenue by plan per month',
  'reports.builtIn.refundsByStaff': 'Refunds by staff',
  'reports.builtIn.newMembersWeekly': 'New members per week',
  'reports.builtIn.visitsByWeekday': 'Visits per weekday',
  'reports.savedHeading': 'Saved',
  'reports.noneSaved': 'Build a report and save it to find it here.',
  'reports.needsRebuilding': 'Needs rebuilding',
  'reports.outdated': 'Outdated',
  'reports.shared': 'Shared',
  'reports.private': 'Private',
  'reports.build': 'Build',
  'reports.untitled': 'Untitled report',
  'reports.edited': 'Edited',
  'reports.resultNote': "{dataset}, {period} in the gym's time zone ({timezone}).",
  'reports.resultNoteCompared': "{dataset}, {period} in the gym's time zone ({timezone}), compared with {comparison}.",
  'reports.saveChanges': 'Save changes',
  'reports.saveAsNew': 'Save as new',
  'reports.rename': 'Rename',
  'reports.invalidSaved': '“{name}” no longer matches what reports can do ({problems}). Build it again and save the changes.',
  'reports.problem.customRange': 'A custom range needs both a from and a to date',
  'reports.problem.minAboveMax': 'The minimum amount is above the maximum amount',
  'reports.saved': 'Report saved',
  'reports.updated': 'Report updated',
  'reports.deleted': 'Report deleted',
  'reports.saveReport': 'Save report',
  'reports.renameReport': 'Rename report',
  'reports.copyName': '{name} (copy)',
  'reports.deleteReport': 'Delete report',
  'reports.deletePrivate': '“{name}” will be deleted.',
  'reports.deleteShared': '“{name}” will be deleted for everyone with finance access.',
  'reports.dataset.memberships': 'Memberships started',
  'reports.dataset.classAttendance': 'Class attendance',
  'reports.range.thisWeek': 'This week',
  'reports.range.lastWeek': 'Last week',
  'reports.range.thisQuarter': 'This quarter',
  'reports.range.lastQuarter': 'Last quarter',
  'reports.range.lastYear': 'Last year',
  'reports.range.custom': 'Custom dates',
  'reports.grouping.quarter': 'Quarter',
  'reports.grouping.weekday': 'Weekday',
  'reports.grouping.plan': 'Plan',
  'reports.grouping.class': 'Class',
  'reports.grouping.trainer': 'Trainer',
  'reports.grouping.tag': 'Tag',
  'reports.paymentMethod': 'Payment method',
  'reports.provider': 'Provider',
  'reports.staff': 'Staff',
  'reports.compare.sameDatesLastYear': 'Same dates last year',
  'reports.measure.averageRefund': 'Average refund',
  'reports.measure.planValue': 'Plan value',
  'reports.measure.memberships': 'Memberships',
  'reports.measure.averagePlanPrice': 'Average plan price',
  'reports.measure.average': 'Average',
  'reports.measure.attendances': 'Attendances',
  'reports.refundedAtProvider': 'Refunded at the provider',
  'reports.noStaff': 'No staff member',
  'reports.noPlan': 'No plan',
  'reports.noTag': 'No tag',
  'reports.none': 'None',
  'reports.data': 'Data',
  'reports.groupBy': 'Group by',
  'reports.thenBy': 'Then by',
  'reports.nothing': 'Nothing',
  'reports.show': 'Show',
  'reports.filters': 'Filters',
  'reports.filtersCount': 'Filters ({count})',
  'reports.archivedPlan': '{name} (archived)',
  'reports.amountIn': 'Amount ({currency})',
  'reports.minimum': 'Minimum',
  'reports.maximum': 'Maximum',
  'reports.clearFilters': 'Clear filters',
  'reports.otherRow': 'Other ({count} more)',
  'reports.previous': 'Previous',
  'reports.change': 'Change',
  'reports.nothingMatched': 'Nothing matched this report in the period.',
  'reports.countedAt': 'Counted at {branches}, the branches you work at.',
  'reports.truncated': 'The {count} largest groups are listed; the rest are added up under Other, so the totals still include them.',
  'reports.visibility': 'Who can see it',
  'reports.visibilityHint': 'Shared reports can be changed by the person who saved them, an owner or an admin.',
  'reports.onlyMe': 'Only me',
  'reports.everyoneWithFinance': 'Everyone with finance access',

  'dailyReport.title': 'Daily report',
  'dailyReport.gym': 'Gym',
  'dailyReport.printTitle': 'Daily cash report · {date}',
  'dailyReport.printed': 'Printed {when}',
  'dailyReport.previousDay': 'Previous day',
  'dailyReport.nextDay': 'Next day',
  'dailyReport.print': 'Print',
  'dailyReport.timezone': 'Gym time zone {timezone} · {from} → {to}',
  'dailyReport.completedCount': '{count} completed',
  'dailyReport.net': 'Net',
  'dailyReport.paidOnThisDay': 'Paid on this day',
  'dailyReport.cashShifts': 'Cash shifts',
  'dailyReport.noShift': 'No drawer shift was open on this day.',
  'dailyReport.shiftCount.one': '{count} shift',
  'dailyReport.shiftCount.other': '{count} shifts',
  'dailyReport.shiftsHint': 'Shifts are opened and closed from the front desk.',
  'dailyReport.opened': 'Opened',
  'dailyReport.closed': 'Closed',
  'dailyReport.float': 'Float',
  'dailyReport.cashSales': 'Cash sales',
  'dailyReport.cashRefunds': 'Cash refunds',
  'dailyReport.cashPaidOut': 'Paid out',
  'dailyReport.expected': 'Expected',
  'dailyReport.counted': 'Counted',
  'dailyReport.difference': 'Difference',
  'dailyReport.stillOpen': 'Still open',
  'dailyReport.emptyTitle': 'No payments on this day',
  'dailyReport.emptyDescription': 'Nothing was paid or refunded on {date}.',
  'dailyReport.noPayments': 'No payments.',
  'dailyReport.paymentsSummary.one': '{count} payment · {amount}',
  'dailyReport.paymentsSummary.other': '{count} payments · {amount}',
  'dailyReport.noPaymentsTaken': 'No payments were taken on this day.',
  'dailyReport.time': 'Time',
  'dailyReport.invoice': 'Invoice',
  'dailyReport.receipt': 'Receipt',
  'dailyReport.planOrDescription': 'Plan / description',
  'dailyReport.recordedBy': 'Recorded by',
  'dailyReport.online': 'Online',
  'dailyReport.refundsSummary.one': '{count} completed refund · {amount}',
  'dailyReport.refundsSummary.other': '{count} completed refunds · {amount}',
  'dailyReport.noRefunds': 'No refunds were completed on this day.',
  'dailyReport.description': 'Description',
};

export const ka: Record<keyof typeof en, string> = {
  'backoffice.provider.manual': 'ხელით',
  'backoffice.selfService': 'ონლაინ / თვითმომსახურება',
  'backoffice.otherPlan': 'სხვა',
  'backoffice.refundStatus.pendingApproval': 'ელოდება დამტკიცებას',
  'backoffice.refundStatus.requested': 'მოთხოვნილია პროვაიდერთან',
  'backoffice.range.thisMonth': 'მიმდინარე თვე',
  'backoffice.range.lastMonth': 'წინა თვე',
  'backoffice.range.last30': 'ბოლო 30 დღე',
  'backoffice.range.thisYear': 'მიმდინარე წელი',
  'backoffice.range.custom': 'მორგებული',
  'backoffice.statement.title': 'თვის ამონაწერი',
  'backoffice.statement.description': 'თვის ყველა გადახდა და დაბრუნება დარბაზის სასაათო სარტყლით, ინვოისის ნომრებითა და ჯამებით, PDF ფორმატში. ეს შიდა საბუღალტრო დოკუმენტია და არა საგადასახადო ანგარიშ-ფაქტურა: საგადასახადო ანგარიშ-ფაქტურები გამოწერეთ rs.ge-ზე.',
  'backoffice.statement.failed': 'ამონაწერი ვერ შეიქმნა',
  'backoffice.downloadPdf': 'PDF-ის ჩამოტვირთვა',
  'backoffice.exportCsv': 'CSV ექსპორტი',
  'backoffice.exportFailed': 'ექსპორტი ვერ მოხერხდა',
  'backoffice.nothingToShow': 'ამ პერიოდში საჩვენებელი არაფერია.',
  'backoffice.count': 'რაოდენობა',
  'backoffice.amount': 'თანხა',
  'backoffice.share': 'წილი',
  'backoffice.total': 'სულ',
  'backoffice.paymentCount.one': '{count} გადახდა',
  'backoffice.paymentCount.other': '{count} გადახდა',
  'backoffice.period': 'პერიოდი',
  'backoffice.from': 'თარიღიდან',
  'backoffice.to': 'თარიღამდე',
  'backoffice.compareWith': 'შედარება',
  'backoffice.previousPeriod': 'წინა პერიოდი',
  'backoffice.today': 'დღეს',
  'backoffice.day': 'დღე',
  'backoffice.week': 'კვირა',
  'backoffice.month': 'თვე',
  'backoffice.payments': 'გადახდები',
  'backoffice.refunds': 'დაბრუნებები',
  'backoffice.refunded': 'დაბრუნებული',
  'backoffice.gross': 'მთლიანი',
  'backoffice.averagePayment': 'საშუალო გადახდა',
  'backoffice.visits': 'ვიზიტები',
  'backoffice.newMembers': 'ახალი წევრები',
  'backoffice.member': 'წევრი',
  'backoffice.method': 'მეთოდი',
  'backoffice.byMethod': 'გადახდის მეთოდის მიხედვით',
  'backoffice.byStaff': 'პერსონალის მიხედვით',

  'analytics.chart': 'დიაგრამა',
  'analytics.noComparison': 'შედარების გარეშე',
  'analytics.rollupNote': 'ჯამები შენახული ციფრებიდან, ბოლო დღე: {date}, გამოთვლილია {time}; უფრო ახალი დღეები ცოცხლად ითვლება.',
  'analytics.vs': 'იყო {value}',
  'analytics.points': '{points} პ.პ.',
  'analytics.fromZero': '0-დან',
  'analytics.quarter': '{quarter} კვ. {year}',
  'analytics.quarterSpan': '{quarter} კვ. {year} ({span})',
  'analytics.weekOf': 'კვირა: {span}',
  'analytics.perDay': '{label} დღეების მიხედვით',
  'analytics.perWeek': '{label} კვირების მიხედვით',
  'analytics.perMonth': '{label} თვეების მიხედვით',
  'analytics.perQuarter': '{label} კვარტლების მიხედვით',
  'analytics.trend.emptyTitle': 'ამ პერიოდისთვის დიაგრამაზე საჩვენებელი არაფერია',
  'analytics.trend.emptyDescription': 'გადახდები, აბონემენტები და ვიზიტები აქ აქტივობის დაწყებისთანავე გამოჩნდება.',
  'analytics.membershipFlow': 'აბონემენტების მოძრაობა',
  'analytics.flow.first': 'პირველი აბონემენტი',
  'analytics.flow.renewed': 'განახლებული ან დაბრუნებული',
  'analytics.flow.churned': 'შეწყვეტილი',
  'analytics.flow.net': 'წმინდა ცვლილება',
  'analytics.flow.activeAtEnd': 'აქტიური პერიოდის ბოლოს',
  'analytics.change': 'ცვლილება',
  'analytics.share': 'წილი ჯამში',
  'analytics.readBars': '{label}. სვეტის წასაკითხად მიიტანეთ მასზე მაუსი ან გამოიყენეთ ისრიანი ღილაკები.',
  'analytics.flow.emptyTitle': 'ამ პერიოდში აბონემენტების მოძრაობა არ ყოფილა',
  'analytics.flow.emptyDescription': 'ახალი, განახლებული და შეწყვეტილი აბონემენტები აქ თითოეული პერიოდისთვის გამოჩნდება.',

  'finance.title': 'ფინანსები',
  'finance.description': 'შემოსავალი, განმეორებადი შემოსავალი და წევრები არჩეული პერიოდისთვის, წინა პერიოდთან შედარებით.',
  'finance.ledger': 'რეესტრი',
  'finance.compare.previousPeriod': 'წინა პერიოდთან შედარებით',
  'finance.compare.lastYear': 'გასულ წელთან შედარებით',
  'finance.compare.lastYearShort': 'გასული წელი',
  'finance.periodNote': '{period}, დარბაზის სასაათო სარტყლით ({timezone}).',
  'finance.periodNoteCompared': '{period}, დარბაზის სასაათო სარტყლით ({timezone}), შედარებულია პერიოდთან {comparison}.',
  'finance.revenue': 'შემოსავალი',
  'finance.revenueDescription': 'გადახდები აღირიცხება გადახდის დღით, დაბრუნებები — დასრულების დღით.',
  'finance.netRevenue': 'წმინდა შემოსავალი',
  'finance.netRevenueHint': 'მთლიანს გამოკლებული დაბრუნებები',
  'finance.grossRevenue': 'მთლიანი შემოსავალი',
  'finance.mrrShort': 'განმეორებადი შემოსავალი (MRR)',
  'finance.trendTitle': 'დინამიკა',
  'finance.trend.perDay': 'დღეების მიხედვით, დარბაზის სასაათო სარტყლით.',
  'finance.trend.perWeek': 'კვირების მიხედვით, დარბაზის სასაათო სარტყლით.',
  'finance.trend.perMonth': 'თვეების მიხედვით, დარბაზის სასაათო სარტყლით.',
  'finance.trend.dashed': 'წყვეტილი ხაზი შედარების პერიოდს აჩვენებს.',
  'finance.granularityLabel': 'დეტალიზაცია',
  'finance.tooMany.day': 'ამ პერიოდისთვის დღეები მეტისმეტად ბევრია',
  'finance.tooMany.week': 'ამ პერიოდისთვის კვირები მეტისმეტად ბევრია',
  'finance.tooMany.month': 'ამ პერიოდისთვის თვეები მეტისმეტად ბევრია',
  'finance.recurringRevenue': 'განმეორებადი შემოსავალი',
  'finance.recurringRevenueDescription': 'პერიოდის ბოლოს აქტიური აბონემენტები და რამდენი დაიწყო, განახლდა და შეწყდა მის განმავლობაში.',
  'finance.mrr': 'ყოველთვიური განმეორებადი შემოსავალი',
  'finance.mrrHint': 'აქტიური აბონემენტების პაკეტების ფასი 30 დღეზე',
  'finance.activeMemberships': 'აქტიური აბონემენტები',
  'finance.autoRenewHint': '{share} ავტომატურად ახლდება',
  'finance.newMemberships': 'ახალი აბონემენტები',
  'finance.newMembershipsHint': 'პირველი — {first}, განმეორებითი — {repeat}',
  'finance.renewals': 'განახლებები',
  'finance.renewalsHint': 'ავტომატური — {count}',
  'finance.churnRate': 'შეწყვეტის მაჩვენებელი',
  'finance.churnRateHint': '{count} დასრულდა გაგრძელების გარეშე',
  'finance.renewalRate': 'განახლების მაჩვენებელი',
  'finance.renewalRateHint': 'განსაახლებელი აბონემენტებიდან',
  'finance.autoRenewShare': 'ავტომატური განახლების წილი',
  'finance.autoRenewShareHint': 'აქტიური აბონემენტებიდან',
  'finance.ended': 'დასრულებული',
  'finance.endedHint': 'ვადა ამოეწურა ან გაუქმდა',
  'finance.flow.perDay': 'დაწყებული აბონემენტები (წევრის პირველი, განახლება ან დაბრუნება) და გაგრძელების გარეშე დასრულებული აბონემენტები, დღეების მიხედვით.',
  'finance.flow.perWeek': 'დაწყებული აბონემენტები (წევრის პირველი, განახლება ან დაბრუნება) და გაგრძელების გარეშე დასრულებული აბონემენტები, კვირების მიხედვით.',
  'finance.flow.perMonth': 'დაწყებული აბონემენტები (წევრის პირველი, განახლება ან დაბრუნება) და გაგრძელების გარეშე დასრულებული აბონემენტები, თვეების მიხედვით.',
  'finance.members': 'წევრები',
  'finance.activeMembers': 'აქტიური წევრები',
  'finance.activeMembersHint': 'პერიოდის ბოლოს აბონემენტით',
  'finance.countedAt': 'დათვლილია აქ: {branches}. აქ მიღებული თანხა (ონლაინ გადახდები არცერთ ფილიალს არ ეკუთვნის), აქ შეძენილი აბონემენტები და მათი მფლობელი წევრები, და შესვლები ამ ფილიალში. ახალი წევრები მთელი დარბაზისაა, რადგან წევრები ყველა ფილიალს ეკუთვნის.',
  'finance.newMembersHint': 'შემოგვიერთდნენ ამ პერიოდში',
  'finance.revenuePerActiveMember': 'შემოსავალი ერთ აქტიურ წევრზე',
  'finance.visitsPerActiveMember': 'ვიზიტები ერთ აქტიურ წევრზე',
  'finance.visitsInPeriod.one': '{count} ვიზიტი ამ პერიოდში',
  'finance.visitsInPeriod.other': '{count} ვიზიტი ამ პერიოდში',
  'finance.atRisk': 'რისკის ქვეშ',
  'finance.atRiskHint': 'აქტიური, ბოლო 14 დღეში ვიზიტის გარეშე',
  'finance.sources': 'საიდან შემოვიდა თანხა',
  'finance.byPlan': 'პაკეტების მიხედვით',
  'finance.byProvider': 'პროვაიდერების მიხედვით',
  'finance.byStaffDescription': 'ვინ დააფიქსირა გადახდა. ონლაინ შენაძენები თვითმომსახურებაშია გაერთიანებული.',
  'finance.outlook': 'პროგნოზი',
  'finance.outlookDescription': 'ამ მომენტისთვის, არჩეული პერიოდის მიუხედავად.',
  'finance.endingIn.one': 'მთავრდება {count} დღეში',
  'finance.endingIn.other': 'მთავრდება {count} დღეში',
  'finance.membershipCount.one': '{count} აბონემენტი',
  'finance.membershipCount.other': '{count} აბონემენტი',
  'finance.endingSoonHint': '{value} პაკეტების ფასებით, შემდეგი აბონემენტი ჯერ არ არის. {count} ავტომატურად განახლდება ({autoRenewValue}).',
  'finance.pendingPayments': 'მოლოდინში მყოფი გადახდები',
  'finance.pendingPaymentsHint': '{count} დაიწყო ბოლო {days} დღეში და ჯერ არ არის გადახდილი',
  'finance.openInLedger': 'რეესტრში გახსნა',
  'finance.refundsAwaitingApproval': 'დასამტკიცებელი დაბრუნებები',
  'finance.requestCount.one': '{count} მოთხოვნა',
  'finance.requestCount.other': '{count} მოთხოვნა',
  'finance.reviewRefunds': 'დაბრუნებების განხილვა',

  'reports.title': 'ანგარიშები',
  'reports.description': 'აირჩიეთ მონაცემები, პერიოდი, დაჯგუფება, ფილტრები და შედარება. შეინახეთ ხედი, რომ ხელახლა გაუშვათ, გაუზიაროთ ფინანსების გუნდს ან გააკეთოთ ექსპორტი.',
  'reports.exportPdf': 'PDF ექსპორტი',
  'reports.library': 'ბიბლიოთეკა',
  'reports.libraryDescription': 'დაიწყეთ ჩაშენებული ან თქვენ მიერ შენახული ანგარიშით.',
  'reports.builtInHeading': 'ჩაშენებული',
  'reports.builtIn.revenueByPlan': 'შემოსავალი პაკეტების მიხედვით, თვეობრივად',
  'reports.builtIn.refundsByStaff': 'დაბრუნებები პერსონალის მიხედვით',
  'reports.builtIn.newMembersWeekly': 'ახალი წევრები კვირების მიხედვით',
  'reports.builtIn.visitsByWeekday': 'ვიზიტები კვირის დღეების მიხედვით',
  'reports.savedHeading': 'შენახული',
  'reports.noneSaved': 'ააწყვეთ ანგარიში და შეინახეთ, რომ აქ იპოვოთ.',
  'reports.needsRebuilding': 'საჭიროებს ხელახლა აწყობას',
  'reports.outdated': 'მოძველებული',
  'reports.shared': 'გაზიარებული',
  'reports.private': 'პირადი',
  'reports.build': 'აწყობა',
  'reports.untitled': 'უსათაურო ანგარიში',
  'reports.edited': 'შეცვლილი',
  'reports.resultNote': '{dataset}, {period}, დარბაზის სასაათო სარტყლით ({timezone}).',
  'reports.resultNoteCompared': '{dataset}, {period}, დარბაზის სასაათო სარტყლით ({timezone}), შედარებულია პერიოდთან {comparison}.',
  'reports.saveChanges': 'ცვლილებების შენახვა',
  'reports.saveAsNew': 'ახლად შენახვა',
  'reports.rename': 'სახელის შეცვლა',
  'reports.invalidSaved': '„{name}“ აღარ შეესაბამება ანგარიშების ამჟამინდელ შესაძლებლობებს ({problems}). ააწყვეთ ხელახლა და შეინახეთ ცვლილებები.',
  'reports.problem.customRange': 'მორგებულ პერიოდს საწყისი და საბოლოო თარიღი ორივე სჭირდება',
  'reports.problem.minAboveMax': 'მინიმალური თანხა მაქსიმალურზე მეტია',
  'reports.saved': 'ანგარიში შეინახა',
  'reports.updated': 'ანგარიში განახლდა',
  'reports.deleted': 'ანგარიში წაიშალა',
  'reports.saveReport': 'ანგარიშის შენახვა',
  'reports.renameReport': 'ანგარიშის სახელის შეცვლა',
  'reports.copyName': '{name} (ასლი)',
  'reports.deleteReport': 'ანგარიშის წაშლა',
  'reports.deletePrivate': '„{name}“ წაიშლება.',
  'reports.deleteShared': '„{name}“ წაიშლება ყველასთვის, ვისაც ფინანსებზე წვდომა აქვს.',
  'reports.dataset.memberships': 'დაწყებული აბონემენტები',
  'reports.dataset.classAttendance': 'ვარჯიშებზე დასწრება',
  'reports.range.thisWeek': 'მიმდინარე კვირა',
  'reports.range.lastWeek': 'წინა კვირა',
  'reports.range.thisQuarter': 'მიმდინარე კვარტალი',
  'reports.range.lastQuarter': 'წინა კვარტალი',
  'reports.range.lastYear': 'გასული წელი',
  'reports.range.custom': 'მორგებული თარიღები',
  'reports.grouping.quarter': 'კვარტალი',
  'reports.grouping.weekday': 'კვირის დღე',
  'reports.grouping.plan': 'პაკეტი',
  'reports.grouping.class': 'ვარჯიში',
  'reports.grouping.trainer': 'ტრენერი',
  'reports.grouping.tag': 'ტეგი',
  'reports.paymentMethod': 'გადახდის მეთოდი',
  'reports.provider': 'პროვაიდერი',
  'reports.staff': 'პერსონალი',
  'reports.compare.sameDatesLastYear': 'იგივე თარიღები გასულ წელს',
  'reports.measure.averageRefund': 'საშუალო დაბრუნება',
  'reports.measure.planValue': 'პაკეტების ღირებულება',
  'reports.measure.memberships': 'აბონემენტები',
  'reports.measure.averagePlanPrice': 'პაკეტის საშუალო ფასი',
  'reports.measure.average': 'საშუალო',
  'reports.measure.attendances': 'დასწრებები',
  'reports.refundedAtProvider': 'დაბრუნდა პროვაიდერთან',
  'reports.noStaff': 'თანამშრომლის გარეშე',
  'reports.noPlan': 'პაკეტის გარეშე',
  'reports.noTag': 'ტეგის გარეშე',
  'reports.none': 'არ არის',
  'reports.data': 'მონაცემები',
  'reports.groupBy': 'დაჯგუფება',
  'reports.thenBy': 'შემდეგ',
  'reports.nothing': 'არაფერი',
  'reports.show': 'ჩვენება',
  'reports.filters': 'ფილტრები',
  'reports.filtersCount': 'ფილტრები ({count})',
  'reports.archivedPlan': '{name} (არქივში)',
  'reports.amountIn': 'თანხა ({currency})',
  'reports.minimum': 'მინიმუმი',
  'reports.maximum': 'მაქსიმუმი',
  'reports.clearFilters': 'ფილტრების გასუფთავება',
  'reports.otherRow': 'სხვა (კიდევ {count})',
  'reports.previous': 'წინა',
  'reports.change': 'ცვლილება',
  'reports.nothingMatched': 'ამ პერიოდში ანგარიშს არაფერი შეესაბამება.',
  'reports.countedAt': 'დათვლილია აქ: {branches} — ფილიალები, სადაც მუშაობთ.',
  'reports.truncated': 'ნაჩვენებია {count} უდიდესი ჯგუფი; დანარჩენები „სხვაში“ ჯამდება, ამიტომ ჯამებში მაინც შედის.',
  'reports.visibility': 'ვის შეუძლია ნახვა',
  'reports.visibilityHint': 'გაზიარებულ ანგარიშს შეცვლა შეუძლია მის შემნახველს, მფლობელს ან ადმინისტრატორს.',
  'reports.onlyMe': 'მხოლოდ მე',
  'reports.everyoneWithFinance': 'ყველა, ვისაც ფინანსებზე წვდომა აქვს',

  'dailyReport.title': 'დღის ანგარიში',
  'dailyReport.gym': 'დარბაზი',
  'dailyReport.printTitle': 'სალაროს დღის ანგარიში · {date}',
  'dailyReport.printed': 'დაიბეჭდა {when}',
  'dailyReport.previousDay': 'წინა დღე',
  'dailyReport.nextDay': 'შემდეგი დღე',
  'dailyReport.print': 'ბეჭდვა',
  'dailyReport.timezone': 'დარბაზის სასაათო სარტყელი {timezone} · {from} → {to}',
  'dailyReport.completedCount': 'დასრულებული — {count}',
  'dailyReport.net': 'წმინდა',
  'dailyReport.paidOnThisDay': 'გადახდილი ამ დღეს',
  'dailyReport.cashShifts': 'სალაროს ცვლები',
  'dailyReport.noShift': 'ამ დღეს სალაროს ცვლა არ გახსნილა.',
  'dailyReport.shiftCount.one': '{count} ცვლა',
  'dailyReport.shiftCount.other': '{count} ცვლა',
  'dailyReport.shiftsHint': 'ცვლები მიმღებიდან იხსნება და იხურება.',
  'dailyReport.opened': 'გაიხსნა',
  'dailyReport.closed': 'დაიხურა',
  'dailyReport.float': 'საწყისი თანხა',
  'dailyReport.cashSales': 'ნაღდი გაყიდვები',
  'dailyReport.cashRefunds': 'ნაღდი დაბრუნებები',
  'dailyReport.cashPaidOut': 'გაცემული თანხა',
  'dailyReport.expected': 'მოსალოდნელი',
  'dailyReport.counted': 'დათვლილი',
  'dailyReport.difference': 'სხვაობა',
  'dailyReport.stillOpen': 'ჯერ ღიაა',
  'dailyReport.emptyTitle': 'ამ დღეს გადახდები არ ყოფილა',
  'dailyReport.emptyDescription': '{date} არც გადახდა ყოფილა და არც დაბრუნება.',
  'dailyReport.noPayments': 'გადახდები არ არის.',
  'dailyReport.paymentsSummary.one': '{count} გადახდა · {amount}',
  'dailyReport.paymentsSummary.other': '{count} გადახდა · {amount}',
  'dailyReport.noPaymentsTaken': 'ამ დღეს გადახდა არ მიღებულა.',
  'dailyReport.time': 'დრო',
  'dailyReport.invoice': 'ინვოისი',
  'dailyReport.receipt': 'ქვითარი',
  'dailyReport.planOrDescription': 'პაკეტი / აღწერა',
  'dailyReport.recordedBy': 'ვინ დააფიქსირა',
  'dailyReport.online': 'ონლაინ',
  'dailyReport.refundsSummary.one': '{count} დასრულებული დაბრუნება · {amount}',
  'dailyReport.refundsSummary.other': '{count} დასრულებული დაბრუნება · {amount}',
  'dailyReport.noRefunds': 'ამ დღეს დაბრუნება არ დასრულებულა.',
  'dailyReport.description': 'აღწერა',
};
